import { AffectedStaffSalary } from '../../../api/affected-staffs/get-payscale'
import { AffectedStaffInput } from '../../types/models/affectedStaff/affected-staff-input'

/**
 * Remuneration shown in the "Rémunération" block: the manual salary when set, otherwise the
 * pay scale (base + bonus) sent by the backend, plus the exceptional bonus for the total
 */
export const getAffectedStaffRemuneration = (
  {
    baseSalary,
    exceptionalBonusAmount
  }: Pick<AffectedStaffInput, 'baseSalary' | 'exceptionalBonusAmount'>,
  payScale?: AffectedStaffSalary
): { salary: number; total: number } => {
  const salary = baseSalary ?? (payScale?.basePrice ?? 0) + (payScale?.bonusPrice ?? 0)
  // The amount input can hold a string while typing
  return { salary, total: salary + Number(exceptionalBonusAmount ?? 0) }
}
